import React from 'react'



const TailorMadeCard = ({ data }) => (
    <div className="relative space-y-2 w-full">
        <div className="bg-[#EE005B] rounded-full flex items-center justify-center w-14 h-14">
            <img src={data.src} className='h-full object-contain scale-50' alt="" />
        </div>
        <div className="text-xl font-bold ">{data.heading}</div>
        <p className="dark:text-gray-300 text-zinc-800 w-[100%] text-md">
            {data.p}
        </p>
    </div>
);

const data = [
    {
        src: "/new-final-data/branding-page/BrandCrafted.png",
        heading: "1200+",
        p: " Brand identities crafted from scratch"
    },
    {
        src: "/new-final-data/branding-page/Rebrands.png",
        heading: "1150+",
        p: " Rebrands that revived businesses"
    },
    {
        src: "/new-final-data/branding-page/CampaignRolledout.png",
        heading: "1300+",
        p: " Campaigns rolled out across industries"
    },
    {
        src: "/new-final-data/branding-page/ClientRetesion.png",
        heading: "95%+",
        p: " Client retention rate through trust-driven branding"
    },
    {
        src: "/new-final-data/branding-page/IndustryCustomize.png",
        heading: "250+",
        p: "Industries we’ve ventured into with customize strategies"
    },
    {
        src: "/new-final-data/branding-page/CreativeAssests.png",
        heading: "11000+",
        p: " Creative assets delivered (logos, brand kits, collaterals, guidelines)"
    },
]


const BrandingSection3 = () => {
    return (
        <div className='w-full xl:px-35 px-10 pt-5 '>
            <div className=' xl:h-[80vh] h-full w-full flex xl:py-20 gap-10 p-5 py-10 flex-col xl:flex-row justify-between dark:bg-zinc-800 bg-zinc-100 rounded-md'>
                <div className='xl:w-[35%] xl:border-r xl:pl-20 dark:border-zinc-600 border-zinc-400'>
                    <div className="">
                        <h3 className='text-sm text-zinc-500 font-semibold uppercase'>UNDER THE BONNET</h3>
                        <h1 className="text-4xl font-bold mt-2 ">
                            Our Impact <br /> in Branding.
                        </h1>
                    </div>
                    <div className="mt-7">
                        <p className="text-lg dark:text-zinc-200">Numbers that speak your brand’s story
                        </p>
                    </div>


                    <div className='grid xl:grid-cols-2 gap-5 mt-4'>
                        <div className='space-y-2'>
                            <h2 className='text-3xl font-bold flex items-center gap-1'>1,000,000<span className='text-lg text-[#EE005B]'>+</span></h2>
                            <p className='text-sm font-bold'> People engaged through our branding campaigns</p>
                        </div>
                        <div className='space-y-2'>
                            <h2 className='text-3xl font-bold flex items-center gap-1'>85%<span className='text-lg text-[#EE005B]'>+</span></h2>
                            <p className='text-sm font-bold'>Fixed support customers</p>
                        </div>
                    </div>

                </div>
                <div className='xl:w-[70%] grid xl:grid-cols-3 grid-cols-2 xl:px-20 xl:gap-10 gap-y-10 gap-5'>
                    {
                        data.map((item, index) => (
                            <>
                                <TailorMadeCard data={item} />
                            </>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default BrandingSection3